import React, { Component } from 'react';
import { graphql } from 'react-relay';
import DistributionBarChart from '../../../../components/DistributionBarChart';
import Gauge from '../../../../components/Gauge';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query SmileysGaugeDistributionWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          useNumbers
          question {
            type
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
            ) {
              count
              ...Gauge_answersReport
              ...DistributionBarChart_answersReport
            }
            ...DistributionBarChart_question
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter()
class SmileysGaugeDistributionWidget extends Component {
  render() {
    const styles = {
      left: {
        display: 'inline-block',
        width: this.props.width * 2 / 5,
      },
      right: {
        display: 'inline-block',
        width: (this.props.width * 3 / 5) - 1, // -1 to make sure both always fit
      },
    };
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <div>
        <div style={styles.left}>
          <Gauge
            answersReport={question.answersReport}
            height={this.props.bodyHeight}
            width={this.props.width * 2 / 5}
            uniqueId={widget.id + '-gauge'}
            widgetConfig={widget.config || {}}
          />
        </div>
        <div style={styles.right}>
          <DistributionBarChart
            question={question}
            answersReport={question.answersReport}
            height={this.props.bodyHeight}
            width={this.props.width * 3 / 5}
            colorBars={true}
            uniqueId={widget.id + '-distribution'}
            widgetConfig={widget.config || {}}

          />
        </div>
      </div>
    );
  }
}

export default SmileysGaugeDistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/SmileysGaugeDistributionWidget/SmileysGaugeDistributionWidget.js